import useTimeNow from '../../hooks/use-time-now';

export interface TimeViewProps {
    time: number | null;
    count: 'up' | 'down';
    onGround?: boolean;
}

export default function TimeView(props: TimeViewProps) {
    const now = useTimeNow({ intervalSeconds: 1 });

    if (props.onGround) {
        return <>-</>;
    }

    if (!props.time) {
        return <>-</>;
    }

    if (props.count === 'up') {
        return <>{formatTimeDiff(now - props.time)}</>;
    } else if (props.count === 'down') {
        return <>{formatTimeDiff(Math.max(0, props.time - now))}</>;
    }

    return <>-</>;
}

function formatTimeDiff(diff: number) {
    if (diff < 60) {
        return diff + 's';
    }

    if (diff < 3600) {
        return Math.floor(diff / 60) + 'min ' + (diff % 60) + 's';
    }

    return Math.floor(diff / 3600) + 'h ' + Math.floor((diff % 3600) / 60) + 'min ' + (diff % 60) + 's';
}
